import { useEffect } from 'react'
import { Avatar, Box, IconEdit } from '@machobear/design-system'
import useProfile from '@/hooks/use-profile'
import { getImageUrl } from '@/utils/image'

type Size = 'small' | 'medium' | 'large'
type Shape = 'rounded' | 'circle'

interface AvatarPickerProps {
  size?: Size
  shape?: Shape
  onSelect?: any
  getInputProps: any
  getRootProps: any
  preview?: string | null
}

export const AvatarPickerDS = ({
  size = 'medium',
  shape = 'rounded',
  getInputProps,
  getRootProps,
  preview
}: AvatarPickerProps) => {
  const profile = useProfile()

  const avatarLocation = getImageUrl(profile?.avatar?.aws_s3_key, { width: 72, height: 72 })
  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview)
    }
  }, [preview])
  return (
    <Box cursor="pointer" tabIndex={0} role="button" position="relative" {...getRootProps()}>
      <Box component="input" name="avatarInput" {...getInputProps()}></Box>
      <Avatar
        img={preview || avatarLocation}
        size={size}
        shape={shape}
        name={profile?.preferred_name}
      />
      <Box
        style={{ width: 24, height: 24, bottom: -7, right: -8, borderWidth: 2 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="circle"
        background="formAccent"
        position="absolute"
        border="borderNeutralLight"
      >
        <Box style={{ width: 14, height: 14 }}>
          <IconEdit size="fill" />
        </Box>
      </Box>
    </Box>
  )
}
